import request from '@/utils/request'

export function quanxianlie(data) {
  return request({
    url: 'houtai.php?k=guanliyuan&c=Wodequanxian',
    method: 'post'
  })
}
export function zongquanxianlie(data) {
  return request({
    url: 'houtai.php?k=guanliyuan&c=Zongquanxian',
    method: 'post'
  })
}

